/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "crop-8dfa41cb--sprite",
  "use": "crop-8dfa41cb--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"crop-8dfa41cb--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-156 -30)\"><g transform=\"translate(166.688 39.563)\"><path d=\"M827.155,1498.234H826.03v-.568a.563.563,0,0,1,1.125,0Z\" transform=\"translate(-823.764 -1497.103)\" fill=\"currentColor\" /><path d=\"M833.995,1513.571v1.125h-6.277a1.692,1.692,0,0,1-1.687-1.687v-7.875h1.125v7.875a.561.561,0,0,0,.563.563Z\" transform=\"translate(-823.764 -1500.616)\" fill=\"currentColor\" /><path d=\"M847.346,1520.7a.564.564,0,0,1-.562.563h-.574v-1.125h.574A.564.564,0,0,1,847.346,1520.7Z\" transform=\"translate(-832.593 -1507.179)\" fill=\"currentColor\" /><path d=\"M833.927,1515.185h0a.563.563,0,0,0,.563-.562v-11.828a1.692,1.692,0,0,0-1.687-1.687H822.565a.562.562,0,0,0-.562.563h0a.563.563,0,0,0,.563.563H832.8a.562.562,0,0,1,.563.563v11.828A.563.563,0,0,0,833.927,1515.185Z\" transform=\"translate(-822.002 -1498.855)\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
